import script from "./AppYesNo.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppYesNo.vue?vue&type=script&setup=true&lang=ts"

import "./AppYesNo.vue?vue&type=style&index=0&id=153d243c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-153d243c"]])

export default __exports__